var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

!function webpackUniversalModuleDefinition(e, t) {
  if ("object" === typeof exports && "object" === typeof module) module.exports = t(require("react"), require("@driftt/tide-core"));else if ("function" === typeof define && define.amd) define(["react", "@driftt/tide-core"], t);else {
    var n = "object" === typeof exports ? t(require("react"), require("@driftt/tide-core")) : t(e.react, e["@driftt/tide-core"]);

    for (var o in n) {
      ("object" === typeof exports ? exports : e)[o] = n[o];
    }
  }
}(window, function (e, t) {
  return function (e) {
    var t = {};

    function __webpack_require__(n) {
      if (t[n]) return t[n].exports;
      var o = t[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, __webpack_require__), o.l = !0, o.exports;
    }

    return __webpack_require__.m = e, __webpack_require__.c = t, __webpack_require__.d = function (e, t, n) {
      __webpack_require__.o(e, t) || Object.defineProperty(e, t, {
        enumerable: !0,
        get: n
      });
    }, __webpack_require__.r = function (e) {
      "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    }, __webpack_require__.t = function (e, t) {
      if (1 & t && (e = __webpack_require__(e)), 8 & t) return e;
      if (4 & t && "object" === typeof e && e && e.__esModule) return e;
      var n = Object.create(null);
      if (__webpack_require__.r(n), Object.defineProperty(n, "default", {
        enumerable: !0,
        value: e
      }), 2 & t && "string" != typeof e) for (var o in e) {
        __webpack_require__.d(n, o, function (t) {
          return e[t];
        }.bind(null, o));
      }
      return n;
    }, __webpack_require__.n = function (e) {
      var t = e && e.__esModule ? function getDefault() {
        return e.default;
      } : function getModuleExports() {
        return e;
      };
      return __webpack_require__.d(t, "a", t), t;
    }, __webpack_require__.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, __webpack_require__.p = "/", __webpack_require__(__webpack_require__.s = 3);
  }([function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    var o;
    !function () {
      "use strict";

      var n = {}.hasOwnProperty;

      function classNames() {
        for (var e = [], t = 0; t < arguments.length; t++) {
          var o = arguments[t];

          if (o) {
            var r = typeof o;
            if ("string" === r || "number" === r) e.push(o);else if (Array.isArray(o) && o.length) {
              var i = classNames.apply(null, o);
              i && e.push(i);
            } else if ("object" === r) for (var s in o) {
              n.call(o, s) && o[s] && e.push(s);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (classNames.default = classNames, e.exports = classNames) : void 0 === (o = function () {
        return classNames;
      }.apply(t, [])) || (e.exports = o);
    }();
  }, function (e, t, n) {
    e.exports = n(9);
  }, function (e, t, n) {
    var o = n(5);
    "string" === typeof o && (o = [[e.i, o, ""]]);
    var r = {
      hmr: !0,
      transform: void 0,
      insertInto: void 0
    };
    n(7)(o, r);
    o.locals && (e.exports = o.locals);
  }, function (e, t, n) {
    (e.exports = n(6)(!0)).push([e.i, ".tide-focus-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--color-p1-2);\n  z-index: 20;\n  transition: all .4s ease;\n  border-top: 8px solid var(--color-p1-10);\n}\n\n.tide-focus-modal-closed {\n  opacity: 0;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.tide-focus-modal-close {\n  cursor: pointer;\n  position: absolute;\n  cursor: pointer;\n  right: 24px;\n  top: 20px;\n}\n\n.tide-focus-modal-body {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  height: 100vh;\n  overflow-y: auto;\n  display: flex;\n  align-content: center;\n  justify-content: space-around;\n}\n\n.tide-focus-modal-body.with-footer {\n  height: calc(100vh - 82px);\n}\n\n.tide-focus-modal-body::-webkit-scrollbar {\n  display: none;\n}\n\n.tide-focus-modal-footer {\n  height: 82px;\n  border-top: 1px solid var(--color-p1-5);\n}\n\n.tide-focus-modal-footer--back-button,\n.tide-focus-modal-footer--next-button  {\n  position: absolute;\n  bottom: 24px;\n}\n\n.tide-focus-modal-footer--back-button {\n  left: 24px;\n}\n\n.tide-focus-modal-footer--next-button {\n  right: 24px;\n}", "", {
      version: 3,
      sources: ["style.css"],
      names: [],
      mappings: "AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,WAAW;EACX,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,uCAAuC;AACzC;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb",
      file: "style.css",
      sourcesContent: [".tide-focus-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: var(--color-p1-2);\n  z-index: 20;\n  transition: all .4s ease;\n  border-top: 8px solid var(--color-p1-10);\n}\n\n.tide-focus-modal-closed {\n  opacity: 0;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.tide-focus-modal-close {\n  cursor: pointer;\n  position: absolute;\n  cursor: pointer;\n  right: 24px;\n  top: 20px;\n}\n\n.tide-focus-modal-body {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  height: 100vh;\n  overflow-y: auto;\n  display: flex;\n  align-content: center;\n  justify-content: space-around;\n}\n\n.tide-focus-modal-body.with-footer {\n  height: calc(100vh - 82px);\n}\n\n.tide-focus-modal-body::-webkit-scrollbar {\n  display: none;\n}\n\n.tide-focus-modal-footer {\n  height: 82px;\n  border-top: 1px solid var(--color-p1-5);\n}\n\n.tide-focus-modal-footer--back-button,\n.tide-focus-modal-footer--next-button  {\n  position: absolute;\n  bottom: 24px;\n}\n\n.tide-focus-modal-footer--back-button {\n  left: 24px;\n}\n\n.tide-focus-modal-footer--next-button {\n  right: 24px;\n}"]
    }]);
  }, function (e, t, n) {
    "use strict";

    e.exports = function (e) {
      var t = [];
      return t.toString = function toString() {
        return this.map(function (t) {
          var n = function cssWithMappingToString(e, t) {
            var n = e[1] || "",
                o = e[3];
            if (!o) return n;

            if (t && "function" === typeof btoa) {
              var r = function toComment(e) {
                return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(e)))) + " */";
              }(o),
                  i = o.sources.map(function (e) {
                return "/*# sourceURL=" + o.sourceRoot + e + " */";
              });

              return [n].concat(i).concat([r]).join("\n");
            }

            return [n].join("\n");
          }(t, e);

          return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
        }).join("");
      }, t.i = function (e, n) {
        "string" === typeof e && (e = [[null, e, ""]]);

        for (var o = {}, r = 0; r < this.length; r++) {
          var i = this[r][0];
          null != i && (o[i] = !0);
        }

        for (r = 0; r < e.length; r++) {
          var s = e[r];
          null != s[0] && o[s[0]] || (n && !s[2] ? s[2] = n : n && (s[2] = "(" + s[2] + ") and (" + n + ")"), t.push(s));
        }
      }, t;
    };
  }, function (e, t, n) {
    var o = {},
        r = function (e) {
      var t;
      return function () {
        return "undefined" === typeof t && (t = e.apply(this, arguments)), t;
      };
    }(function () {
      return window && document && document.all && !window.atob;
    }),
        i = function (e) {
      var t = {};
      return function (e, n) {
        if ("function" === typeof e) return e();

        if ("undefined" === typeof t[e]) {
          var o = function (e, t) {
            return t ? t.querySelector(e) : document.querySelector(e);
          }.call(this, e, n);

          if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) try {
            o = o.contentDocument.head;
          } catch (r) {
            o = null;
          }
          t[e] = o;
        }

        return t[e];
      };
    }(),
        s = null,
        a = 0,
        c = [],
        l = n(8);

    function addStylesToDom(e, t) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n],
            i = o[r.id];

        if (i) {
          i.refs++;

          for (var s = 0; s < i.parts.length; s++) {
            i.parts[s](r.parts[s]);
          }

          for (; s < r.parts.length; s++) {
            i.parts.push(addStyle(r.parts[s], t));
          }
        } else {
          var a = [];

          for (s = 0; s < r.parts.length; s++) {
            a.push(addStyle(r.parts[s], t));
          }

          o[r.id] = {
            id: r.id,
            refs: 1,
            parts: a
          };
        }
      }
    }

    function listToStyles(e, t) {
      for (var n = [], o = {}, r = 0; r < e.length; r++) {
        var i = e[r],
            s = t.base ? i[0] + t.base : i[0],
            a = {
          css: i[1],
          media: i[2],
          sourceMap: i[3]
        };
        o[s] ? o[s].parts.push(a) : n.push(o[s] = {
          id: s,
          parts: [a]
        });
      }

      return n;
    }

    function insertStyleElement(e, t) {
      var n = i(e.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var o = c[c.length - 1];
      if ("top" === e.insertAt) o ? o.nextSibling ? n.insertBefore(t, o.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), c.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
        if ("object" !== typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var r = i(e.insertAt.before, n);
        n.insertBefore(t, r);
      }
    }

    function removeStyleElement(e) {
      if (null === e.parentNode) return !1;
      e.parentNode.removeChild(e);
      var t = c.indexOf(e);
      t >= 0 && c.splice(t, 1);
    }

    function createStyleElement(e) {
      var t = document.createElement("style");

      if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
        var o = function getNonce() {
          0;
          return n.nc;
        }();

        o && (e.attrs.nonce = o);
      }

      return addAttrs(t, e.attrs), insertStyleElement(e, t), t;
    }

    function addAttrs(e, t) {
      Object.keys(t).forEach(function (n) {
        e.setAttribute(n, t[n]);
      });
    }

    function addStyle(e, t) {
      var n, o, r, i;

      if (t.transform && e.css) {
        if (!(i = "function" === typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
        e.css = i;
      }

      if (t.singleton) {
        var c = a++;
        n = s || (s = createStyleElement(t)), o = applyToSingletonTag.bind(null, n, c, !1), r = applyToSingletonTag.bind(null, n, c, !0);
      } else e.sourceMap && "function" === typeof URL && "function" === typeof URL.createObjectURL && "function" === typeof URL.revokeObjectURL && "function" === typeof Blob && "function" === typeof btoa ? (n = function createLinkElement(e) {
        var t = document.createElement("link");
        return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", addAttrs(t, e.attrs), insertStyleElement(e, t), t;
      }(t), o = function updateLink(e, t, n) {
        var o = n.css,
            r = n.sourceMap,
            i = void 0 === t.convertToAbsoluteUrls && r;
        (t.convertToAbsoluteUrls || i) && (o = l(o));
        r && (o += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(r)))) + " */");
        var s = new Blob([o], {
          type: "text/css"
        }),
            a = e.href;
        e.href = URL.createObjectURL(s), a && URL.revokeObjectURL(a);
      }.bind(null, n, t), r = function r() {
        removeStyleElement(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = createStyleElement(t), o = function applyToTag(e, t) {
        var n = t.css,
            o = t.media;
        o && e.setAttribute("media", o);
        if (e.styleSheet) e.styleSheet.cssText = n;else {
          for (; e.firstChild;) {
            e.removeChild(e.firstChild);
          }

          e.appendChild(document.createTextNode(n));
        }
      }.bind(null, n), r = function r() {
        removeStyleElement(n);
      });

      return o(e), function updateStyle(t) {
        if (t) {
          if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
          o(e = t);
        } else r();
      };
    }

    e.exports = function (e, t) {
      if ("undefined" !== typeof DEBUG && DEBUG && "object" !== typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
      (t = t || {}).attrs = "object" === typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" === typeof t.singleton || (t.singleton = r()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
      var n = listToStyles(e, t);
      return addStylesToDom(n, t), function update(e) {
        for (var r = [], i = 0; i < n.length; i++) {
          var s = n[i];
          (a = o[s.id]).refs--, r.push(a);
        }

        e && addStylesToDom(listToStyles(e, t), t);

        for (i = 0; i < r.length; i++) {
          var a;

          if (0 === (a = r[i]).refs) {
            for (var c = 0; c < a.parts.length; c++) {
              a.parts[c]();
            }

            delete o[a.id];
          }
        }
      };
    };

    var u = function () {
      var e = [];
      return function (t, n) {
        return e[t] = n, e.filter(Boolean).join("\n");
      };
    }();

    function applyToSingletonTag(e, t, n, o) {
      var r = n ? "" : o.css;
      if (e.styleSheet) e.styleSheet.cssText = u(t, r);else {
        var i = document.createTextNode(r),
            s = e.childNodes;
        s[t] && e.removeChild(s[t]), s.length ? e.insertBefore(i, s[t]) : e.appendChild(i);
      }
    }
  }, function (e, t) {
    e.exports = function (e) {
      var t = "undefined" !== typeof window && window.location;
      if (!t) throw new Error("fixUrls requires window.location");
      if (!e || "string" !== typeof e) return e;
      var n = t.protocol + "//" + t.host,
          o = n + t.pathname.replace(/\/[^\/]*$/, "/");
      return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
        var r,
            i = t.trim().replace(/^"(.*)"$/, function (e, t) {
          return t;
        }).replace(/^'(.*)'$/, function (e, t) {
          return t;
        });
        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? e : (r = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : o + i.replace(/^\.\//, ""), "url(" + JSON.stringify(r) + ")");
      });
    };
  }, function (e, t, n) {
    "use strict";

    n.r(t);
    var o = n(0),
        r = n.n(o),
        i = n(1),
        s = n(2),
        a = n.n(s);
    n(4);
    var c = {
      BEGINNING: "beginning",
      CURRENT: "current"
    };

    var l = /*#__PURE__*/function (_o$Component) {
      _inherits(FocusModal_FocusModal, _o$Component);

      var _super = _createSuper(FocusModal_FocusModal);

      function FocusModal_FocusModal(e) {
        var _this;

        _classCallCheck(this, FocusModal_FocusModal);

        _this = _super.call(this, e), _this.initialState = {
          stepIndex: _this.props.initialStepIndex || 0,
          canGoBack: _this.props.initialStepIndex && _this.props.initialStepIndex > 0 && _this.props.initialStepIndex < _this.props.steps.length,
          canContinue: !!_this.props.steps && _this.props.steps.length > 1
        }, _this.onContinue = function () {
          var e = _this.state,
              t = e.stepIndex,
              n = e.canContinue,
              o = e.onContinueCallback,
              r = void 0 === o ? function () {} : o,
              i = _this.props.steps,
              s = t + 1;
          n && (_this.setState({
            stepIndex: s,
            canContinue: s < i.length - 1,
            canGoBack: !0
          }), r());
        }, _this.onBack = function () {
          var e = _this.state,
              t = e.stepIndex,
              n = e.canGoBack,
              o = e.onBackCallback,
              r = void 0 === o ? function () {} : o,
              i = t - 1;
          n && (_this.setState({
            stepIndex: i,
            canContinue: !0,
            canGoBack: 0 !== i
          }), r());
        }, _this.onSkipToStep = function (e) {
          var t = _this.props.steps;
          e >= 0 && e < t.length && _this.setState({
            stepIndex: e,
            canContinue: e < t.length - 1,
            canGoBack: e > 0
          });
        }, _this.closeModal = function () {
          var e = _this.props,
              t = e.onClose,
              n = void 0 === t ? function () {} : t,
              o = e.reopenStep,
              r = void 0 === o ? c.CURRENT : o;
          n(), r === c.BEGINNING && setTimeout(function () {
            return _this.setState(_this.initialState);
          }, 400);
        }, _this.state = _this.initialState;
        return _this;
      }

      _createClass(FocusModal_FocusModal, [{
        key: "render",
        value: function render() {
          var e = this.props,
              t = e.open,
              n = e.steps,
              o = void 0 === n ? [] : n,
              s = e.hasFooter,
              c = this.state,
              l = c.stepIndex,
              u = c.canContinue,
              p = c.canGoBack,
              f = o[l],
              d = s && f && (p || u);
          return r.a.createElement(i.Div, {
            className: a()("tide-focus-modal", {
              "tide-focus-modal-closed": !t
            })
          }, r.a.createElement(i.Div, {
            className: "tide-focus-modal-close",
            onClick: this.closeModal
          }, r.a.createElement(i.IconButton, {
            icon: "close"
          })), r.a.createElement(i.Div, {
            className: a()("tide-focus-modal-body", {
              "with-footer": d
            })
          }, !!f && r.a.createElement(f, {
            onBack: this.onBack,
            onContinue: this.onContinue,
            canContinue: u,
            canGoBack: p,
            onSkipToStep: this.onSkipToStep
          })), d && r.a.createElement(i.Div, {
            className: "tide-focus-modal-footer"
          }, p && r.a.createElement(i.Button, {
            className: "tide-focus-modal-footer--back-button",
            type: "tertiary",
            onClick: this.onBack
          }, "Back"), u && r.a.createElement(i.Button, {
            className: "tide-focus-modal-footer--next-button",
            onClick: this.onContinue
          }, "Next")));
        }
      }]);

      return FocusModal_FocusModal;
    }(o.Component);

    n.d(t, "FocusModal", function () {
      return l;
    });
  }]);
});